
  var _styles = {
  "app-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "paddingTop": "0.32rem"
  },
  "three-column-container": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "justifyContent": "flex-start",
    "width": "100%",
    "paddingLeft": "0.32rem"
  }
};



  module.exports = _styles;
  